<!-- <gd-addtrans *ngIf="!newAccount"></gd-addtrans> -->
<div id="blotter" *ngIf="blotId">Transaction ID: {{ blotId }}</div>
<a
  (click)="viewFilestransaction()"
  routerLinkActive="router-link-active"
  *ngIf="blotId"
>
  <ng-icon name="heroFolder" style="font-size: 15px" title="View Files"></ng-icon>
  <span style="font-size: small; cursor: pointer">
    View Files for this Transaction
  </span>
</a>
<a
  *ngIf="blotId"
  (click)="viewFilesaccount()"
  routerLinkActive="router-link-active"
>
  <ng-icon name="heroFolder" style="font-size: 15px" title="View Files"></ng-icon>
  <span style="font-size: small; cursor: pointer">
    View Files for this Account
  </span> <!--  -->
</a>
<div kendoWindowContainer ></div>
<div kendoDialogContainer></div>
<p *ngIf="showAccountFormReviewTab && accountFormReviewPending" class="text-red-600 font-bold text-sm mt-2">
  There is an account review form that must be completed for this account.
</p>
<kendo-tabstrip [keepTabContent]="true" (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab
    [title]="'Transaction'"
    [selected]="selectedTab == 'transaction'"
    *ngIf="showTransactionTab"
  >
    <ng-template kendoTabContent>
      @if (reloadTransaction) {
        <gd-addtrans (passclientId)="clientdata($event)"></gd-addtrans>
      }
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab
    [title]="'Review'"
    [selected]="selectedTab == 'review Summary'"
    *ngIf="showReviewTransactionTab"
  >
    <ng-template kendoTabContent>
      <div class="cardrounded-2xl shadow p-6 my-4 flex flex-col gap-4" [class.opacity-50]="loading">
        <p class="font-bold">Supervisory Review</p>
        <gd-rvstep2form
          #step2Component
          (submitEvent)="onSubmit($event)"
          [loading]="spinnerload"
          (stopLoader)="loaderstop($event)"
        ></gd-rvstep2form>
        <div *ngIf="loading" class="absolute inset-0 flex items-center justify-center bg-white/80 rounded-2xl z-10">
          <span class="loader"></span>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab
    [title]="'Account Form Review'"
    [selected]="selectedTab == 'account form review'"
    *ngIf="showAccountFormReviewTab"
  >
    <ng-template kendoTabContent>
      <div class="card rounded-2xl shadow p-6 my-4 flex flex-col gap-4" [class.opacity-50]="loading">
        <p class="font-bold">Review questions</p>
        <gd-rv-step3-new-form
          #step3Component
          (submitNewAccEvent)="onSubmitnewAcc($event)"
          (stopLoader)="loaderstop($event)"
          (reviewApprovalStatus)="onReviewApprovalStatus($event)"
        ></gd-rv-step3-new-form>
        <div *ngIf="loading" class="absolute inset-0 flex items-center justify-center bg-white/80 rounded-2xl z-10">
          <span class="loader"></span>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab
    [title]="'Account Form PDF'"
    [selected]="selectedTab == 'account form pdf'"
    *ngIf="showAccountFormPdfTab"
  >
    <ng-template kendoTabContent>
      <div class="cardrounded-2xl shadow p-6 my-4">
        <div *ngIf="accountFormPdfTabError" class="p-4 mb-4 text-red-600 bg-red-50 border border-red-200 rounded">
          <strong>Error:</strong> {{ accountFormPdfTabError }}
        </div>
        <gd-tabAccountfileslist *ngIf="!accountFormPdfTabError" [rawPdfData]="selectedFormData" (otherFilesChanged)="onAccountFilesChanged($event)"></gd-tabAccountfileslist>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab
    [title]="'Drivers License'"
    [selected]="selectedTab == 'drivers license'"
    *ngIf="showLicenseTab"
  >
    <ng-template kendoTabContent>
      <div class="card rounded-2xl shadow p-4 my-4 h-full">
        <div *ngIf="licenseTabError" class="p-4 mb-4 text-red-600 bg-red-50 border border-red-200 rounded">
          <strong>Error:</strong> {{ licenseTabError }}
        </div>
        <gd-licenceview *ngIf="!licenseTabError" [rawPdfDataViewer]="selectedFormDataviewer"></gd-licenceview>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab
    [title]="clientName + ' Trans ID: ' + blotId"
    *ngIf="clientfiles"
  >
    <ng-template kendoTabContent>
      <div class="card rounded-2xl shadow p-6 my-4">
        <gd-tabfilestransactionlist (clientFilesChanged)="onClientFilesChanged($event)"></gd-tabfilestransactionlist>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title]="'Correspondence'" *ngIf="correspondfiles">
    <ng-template kendoTabContent>
      <div class="card rounded-2xl shadow p-6 my-4">
        <gd-tabcorrespondencefileslist (corresponFilesChanged)="onCorresponFilesChanged($event)"></gd-tabcorrespondencefileslist>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title]="'Other'" *ngIf="otherfiles">
    <ng-template kendoTabContent>
      <div class="card rounded-2xl shadow p-6 my-4">
        <gd-tabotherfileslist (otherFilesChanged)="onOtherFilesChanged($event)"></gd-tabotherfileslist>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
